/* GRAVENTO — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al hacer scroll (un solo observador para todo) */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gv-reveal:not(.gv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cifras que cuentan al entrar en pantalla */
  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-gv-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-gv-contar')) || 0;
      if (reduce) { el.textContent = fin; return; }
      var dur = 1800, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Comparador antes / después */
  function initComparadores(root) {
    (root || document).querySelectorAll('.gv-comp').forEach(function (comp) {
      var input = comp.querySelector('input[type=range]');
      if (!input) return;
      function set() { comp.style.setProperty('--gv-pos', input.value + '%'); }
      input.addEventListener('input', set);
      set();
    });
  }

  /* Zoom suave de la imagen del hero al hacer scroll */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-gv-parallax] img');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var k = parseFloat(img.parentElement.getAttribute('data-gv-parallax')) || 1;
        img.style.transform = 'scale(1.08) translateY(' + (p * 24 * k).toFixed(2) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Galería de la página de producto */
  function initGalerias(root) {
    (root || document).querySelectorAll('[data-gv-galeria]').forEach(function (gal) {
      var imgs = gal.querySelectorAll('.gv-galeria__principal img');
      var thumbs = gal.querySelectorAll('.gv-galeria__miniaturas button');
      if (imgs.length < 2) return;
      var actual = 0;
      function ir(i) {
        actual = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('gv-activa', k === actual); });
        thumbs.forEach(function (b, k) { b.classList.toggle('gv-activa', k === actual); });
      }
      thumbs.forEach(function (b, k) { b.addEventListener('click', function () { ir(k); }); });
      var prev = gal.querySelector('.gv-galeria__flecha--prev');
      var next = gal.querySelector('.gv-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null;
      var principal = gal.querySelector('.gv-galeria__principal');
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* Formulario de compra: cantidad, variantes y barra fija móvil */
  function initCompra(root) {
    (root || document).querySelectorAll('[data-gv-producto]').forEach(function (wrap) {
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var qty = wrap.querySelector('.gv-cantidad input');
      wrap.querySelectorAll('.gv-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += b.getAttribute('data-gv-paso') === '+' ? 1 : -1;
          qty.value = Math.max(1, v);
        });
      });

      var dataEl = wrap.querySelector('script[data-gv-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = form.querySelector('input[name=id]');
      var btns = wrap.querySelectorAll('[data-gv-btn-compra]');
      var precios = wrap.querySelectorAll('[data-gv-precio]');
      var antes = wrap.querySelectorAll('[data-gv-precio-antes]');
      var fmt = wrap.getAttribute('data-gv-moneda') || '${{amount_no_decimals}}';

      function money(cents) {
        var n = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
      }

      wrap.querySelectorAll('.gv-variantes input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          wrap.querySelectorAll('.gv-variantes').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (vv) {
            return vv.options.every(function (o, i) { return o === sel[i]; });
          });
          if (!v) return;
          idInput.value = v.id;
          precios.forEach(function (p) { p.textContent = money(v.price); });
          antes.forEach(function (a) {
            var promo = a.closest('[data-gv-promo]') || a;
            if (v.compare_at_price > v.price) {
              a.textContent = money(v.compare_at_price);
              var pct = promo.querySelector('[data-gv-promo-pct]');
              if (pct) pct.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
              promo.hidden = false;
            } else promo.hidden = true;
          });
          btns.forEach(function (b) {
            b.disabled = !v.available;
            var label = b.querySelector('[data-gv-btn-texto]');
            if (label) label.textContent = v.available ? b.getAttribute('data-gv-texto-ok') : b.getAttribute('data-gv-texto-agotado');
          });
        });
      });

      var barra = document.querySelector('.gv-barra-fija');
      if (barra && 'IntersectionObserver' in window) {
        var objetivo = wrap.querySelector('.gv-compra');
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { barra.classList.toggle('gv-mostrar', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(objetivo);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () {
          var principal = form.querySelector('[data-gv-btn-compra]');
          if (principal) principal.click();
        });
      }
    });
  }

  function initTodo(root) {
    initReveal(root); initContadores(root); initComparadores(root); initGalerias(root); initCompra(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); initParallax(); });
  /* Editor de Shopify: re-inicializar al añadir o cambiar una sección */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
